<label
    class="flex cursor-pointer select-none flex-row items-center gap-3"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
>
    <div class="relative h-6 w-11 flex-shrink-0">
        <input
            type="checkbox"
            [checked]="value"
            (change)="onToggle()"
            [disabled]="disabled"
            class="peer sr-only"
        />
        <div
            class="absolute inset-0 rounded-full transition-all duration-200 ease-in-out peer-focus:ring-4 peer-focus:ring-primary-100"
            [ngClass]="{
                'bg-primary-500': value,
                'bg-slate-300': !value,
            }"
        ></div>
        <div
            class="absolute left-1 top-1 h-4 w-4 rounded-full bg-white shadow-md transition-transform duration-200 ease-in-out"
            [ngClass]="{
                'translate-x-5 transform': value,
            }"
        ></div>
    </div>
    @if (label) {
        <div
            class="flex items-center gap-x-3 text-sm text-slate-700 md:text-base"
        >
            <span>{{ label }}</span>
            @if (showTooltip && tooltipText) {
                <span
                    class="fa-light fa-info-circle ms-2 cursor-pointer text-slate-400 hover:text-slate-600"
                    data-toggle="tooltip"
                    [appTooltip]="tooltipText"
                    data-placement="top"
                ></span>
            }
        </div>
    }
</label>
